import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';

export interface DataSummary {
  bullet_points: string[];
  key_statistics: KeyStatistic[];
  overall_assessment: string;
  generated_at?: string;
}

export interface KeyStatistic {
  category: string;
  description: string;
  value: string;
  importance_score?: number;
  scope?: string; // 'TABLE' or 'COLUMN'
}

@Component({
  selector: 'app-data-summary',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatExpansionModule],
  templateUrl: './data-summary.component.html',
  styleUrls: ['./data-summary.component.scss']
})
export class DataSummaryComponent {
  @Input() summary: DataSummary | null = null;
  @Input() title: string = 'Data Summary';
  @Input() expanded: boolean = true;

  getCategoryIcon(scope: string | undefined): string {
    if (!scope) {
      return 'analytics';
    }
    
    if (scope === 'TABLE') {
      return 'table_chart';
    } else if (scope === 'COLUMN') {
      return 'view_column';
    }
    
    return 'analytics';
  }

  getCategoryColor(scope: string | undefined): string {
    if (!scope) {
      return 'scope-default';
    }
    
    if (scope === 'TABLE') {
      return 'scope-table';
    } else if (scope === 'COLUMN') {
      return 'scope-column';
    }
    
    return 'scope-default';
  }
}
